import React, { useEffect, useState } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const PrApprovalViewFinal = () => {
   useAuthRedirect();
  const [data, setData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const user = localStorage.getItem("username");
  const [loading, setLoading] = useState(false);
   const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

   const canView  = hasPermission("Department", "view");
  const canEntry = hasPermission("Department", "entry");

 const fetchData = async () => {
  setLoading(true);
  try {
    const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_finalApproval`);
    setData(response.data.appList);
    setFilteredData(response.data.appList);
  } catch (error) {
    console.error("Error fetching appList:", error);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchData(); // initial load
}, []);
 

  const handleApprove = async (prHeader_number) => {
  if (!prHeader_number) return;

  const result = await Swal.fire({
    title: "Are you sure?",
    text: "Do you really want to approve this bill?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Approve!",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
       Swal.fire({
                  title: "Submitting...",
                  text: "Please wait while we process your request.",
                  allowOutsideClick: false,
                  didOpen: () => {
                      Swal.showLoading();
                  },
              });
      const response = await axios.put(
        "https://rfs2.infraconsoft.net.in/api/purchaseReq_finalAppovalForPurchase",
        { prHeader_number, user }
      );

      if (response.data.success) {
        await Swal.fire({
          title: "Approved!",
          text: "Request Approved Successfully!",
          icon: "success",
        });

        // Refresh data after approval
        fetchData();
      } else {
        Swal.fire({
          title: "Failed!",
          text: "Failed to Approve.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error approving bill:", error);
      Swal.fire({
        title: "Error!",
        text: "Error processing approval.",
        icon: "error",
      });
    }
  }
};
const handleDisapprove = async (prHeader_number) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "Do you really want to disapprove this Request?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Disapprove!",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
             Swal.fire({
                  title: "Submitting...",
                  text: "Please wait while we process your request.",
                  allowOutsideClick: false,
                  didOpen: () => {
                      Swal.showLoading();
                  },
              });
      const response = await axios.put("https://rfs2.infraconsoft.net.in/api/purchaseReq_finalDisAppovalForPurchase", {
        prHeader_number,
        user,
      });

      

      if (response.data.success) {
  Swal.fire("Disapproved!", "Request Disapproved!", "success").then(() => {
    fetchData();
  });
}
 else {
        Swal.fire("Failed!", "Failed to Disapprove Bill.", "error");
      }
    } catch (error) {
      console.error("Error disapproving bill:", error);
      Swal.fire("Error!", "Error processing disapproval.", "error");
    }
  }
};

if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

   // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
 
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
        setFilteredData(data);
        return;
    }

    const filtered = data.filter((item) => 
        String(item.prDetail_number || "").toLowerCase().includes(term) || 
    String(item.supplierMaster_name || "").toLowerCase().includes(term) || 
    String(item.suppliermaster_code || "").toLowerCase().includes(term) 
    );

    setFilteredData(filtered);
};


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Prior Purchase Final Approval
          </h2>
          <div>
            <Time />
          </div>
        </section>





 {/* Search Filter */}
 <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by PR No / Supplier" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Type</th>
                <th>Pr No</th>
                <th>Date</th>
                <th>Supplier</th>
                <th>Supplier Name</th>
                <th>Value</th>
                {canEntry && (
                  <>
                <th>Approval</th>
                <th>Dis Approval</th>
                </>
                )}
              </tr>
            </thead>
           <tbody>
  {loading ? (
    <tr>
      <td colSpan="9" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    <>
      {currentData.map((item, index) => (
        <tr key={index}>
          <td>{indexOfFirstItem + index + 1}</td>
          <td>{item.branchCode}</td>
          <td>{item.prHeader_Type}</td>
          <td>{item.prDetail_number}</td>
          <td>{item.prHeader_date ? new Date(item.prHeader_date).toISOString().split("T")[0] : ""}</td>
          <td>{item.supplierMaster_code}</td>
          <td>{item.supplierMaster_name}</td>
          <td>
  {new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(item.price)}
</td>

          {canEntry && (
            <>
              <td>
                <button className="approve-btn" onClick={() => handleApprove(item.prHeader_number)}>✅ Approve</button>
              </td>
              <td>
                <button className="disapprove-btn" onClick={() => handleDisapprove(item.prHeader_number)}>❌ Disapprove</button>
              </td>
            </>
          )}
        </tr>
      ))}

      {/* Total Value Row for All Records */}
      <tr>
  <td colSpan={7}><strong>Total Value</strong></td>
  <td>
    <strong>
      {new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(
        data.reduce((total, item) => total + Number(item.price || 0), 0)
      )}
    </strong>
  </td>
</tr>

    </>
  ) : (
    <tr>
      <td colSpan="9">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>

       {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrApprovalViewFinal;
